// EMPORIOGO — utilidades compartidas de las secciones mt-*
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initSelectorVariantes();
  initComparador();
  initCarrusel();
  initAcordeon();
  initContador();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria-producto]').forEach(function (galeria) {
    var carrusel = galeria.querySelector('[data-mt-carrusel-principal]');
    var slides = galeria.querySelectorAll('[data-mt-slide]');
    var puntos = galeria.querySelectorAll('[data-mt-punto]');
    var minis = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!carrusel || !slides.length) return;

    function irA(indice) {
      var slide = slides[indice];
      if (!slide) return;
      carrusel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    function marcarActivo(indice) {
      puntos.forEach(function (p, i) { p.classList.toggle('mt-punto-activo', i === indice); });
      minis.forEach(function (m, i) { m.classList.toggle('mt-miniatura-activa', i === indice); });
    }

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        irA(parseInt(punto.getAttribute('data-indice'), 10));
      });
    });
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        irA(parseInt(mini.getAttribute('data-indice'), 10));
      });
    });

    var raf = null;
    carrusel.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var indice = Math.round(carrusel.scrollLeft / carrusel.clientWidth);
        marcarActivo(indice);
      });
    }, { passive: true });
  });
}

function initSelectorVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-mt-opcion]');
    var inputId = form.querySelector('[data-mt-input-id]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioTachadoEl = form.querySelector('[data-mt-precio-tachado]');
    var botonComprar = form.querySelector('[data-mt-btn-comprar]');
    var estadoEl = form.querySelector('[data-mt-estado-stock]');

    function moneda(centavos) {
      return form.getAttribute('data-mt-money-format').replace('{{amount}}', (centavos / 100).toFixed(2));
    }

    function encontrarVariante() {
      var valores = [];
      selects.forEach(function (sel) { valores.push(sel.value); });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      if (!selects.length) return;
      var variante = encontrarVariante();
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioTachadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachadoEl.textContent = moneda(variante.compare_at_price);
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (botonComprar) botonComprar.disabled = !variante.available;
      if (estadoEl) estadoEl.textContent = variante.available ? estadoEl.getAttribute('data-disponible') : estadoEl.getAttribute('data-agotado');
    }

    selects.forEach(function (sel) { sel.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
    var asa = comp.querySelector('[data-mt-comparador-asa]');
    var despues = comp.querySelector('[data-mt-comparador-despues]');
    if (!asa || !despues) return;

    function mover(porcentaje) {
      porcentaje = Math.max(0, Math.min(100, porcentaje));
      despues.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
      asa.style.left = porcentaje + '%';
    }

    var rectCache = null;
    function porcentajeDesdeEvento(clientX) {
      var rect = rectCache || comp.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var arrastrando = false;
    asa.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      rectCache = comp.getBoundingClientRect();
      asa.setPointerCapture(e.pointerId);
    });
    asa.addEventListener('pointerup', function () { arrastrando = false; rectCache = null; });
    comp.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      mover(porcentajeDesdeEvento(e.clientX));
    });
    comp.addEventListener('click', function (e) {
      if (e.target === asa) return;
      mover(porcentajeDesdeEvento(e.clientX));
    });
    mover(50);
  });
}

function initCarrusel() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (carrusel) {
    var pista = carrusel.querySelector('[data-mt-carrusel-pista]');
    var prev = carrusel.querySelector('[data-mt-carrusel-prev]');
    var next = carrusel.querySelector('[data-mt-carrusel-next]');
    if (!pista) return;
    var paso = function () {
      var tarjeta = pista.querySelector(':scope > *');
      return tarjeta ? tarjeta.getBoundingClientRect().width + 20 : 300;
    };
    if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
  });
}

function initAcordeon() {
  document.querySelectorAll('[data-mt-acordeon-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-acordeon-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-acordeon-abierto');
      item.closest('[data-mt-acordeon]').querySelectorAll('[data-mt-acordeon-item]').forEach(function (i) {
        i.classList.remove('mt-acordeon-abierto');
      });
      if (!abierto) item.classList.add('mt-acordeon-abierto');
    });
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (fin % 1 === 0 ? Math.round(valor) : valor.toFixed(1)).toString().replace('.', ',');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toString().replace('.', ',');
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}
